import { Prompt, Course, Challenge } from '@ai-platform/ai-utils';
import { transformCourseToCard } from '../course/mappers';

// Счетчики для отслеживания последовательности промптов
let consecutiveEditorialCount = 0;
let consecutiveNonEditorialCount = 0;

/**
 * Адаптация данных промпта из API под формат frontend
 */
//eslint-disable-next-line @typescript-eslint/no-explicit-any
export const transformApiPromptToFrontend = (apiPrompt: Prompt): any => {
    // Определяем isEditorial с учетом ограничения на последовательность
    let isEditorial: boolean;

    if (apiPrompt.author?.uid !== '0') {
        isEditorial = false;
        consecutiveEditorialCount = 0;
        consecutiveNonEditorialCount = 1;
    } else if (consecutiveEditorialCount >= 2) {
        // Если уже 2 подряд editorial, следующий обязательно не-editorial
        isEditorial = false;
        consecutiveEditorialCount = 0;
        consecutiveNonEditorialCount = 1;
    } else if (consecutiveNonEditorialCount >= 2) {
        // Если уже 2 подряд не-editorial, следующий обязательно editorial
        isEditorial = true;
        consecutiveNonEditorialCount = 0;
        consecutiveEditorialCount = 1;
    } else {
        // Иначе используем случайное распределение (50% вероятность)
        isEditorial = Math.random() < 0.5;

        if (isEditorial) {
            consecutiveNonEditorialCount = 0;
            consecutiveEditorialCount++;
        } else {
            consecutiveEditorialCount = 0;
            consecutiveNonEditorialCount++;
        }
    }

    return {
        ...apiPrompt,
        type: 'prompt',
        // id: apiPrompt.id,
        // title: apiPrompt.title,
        // description: apiPrompt.description,
        // categories: apiPrompt.categories,
        // prompt: apiPrompt.prompt,
        // prompt_for_example: apiPrompt.promptForExample,
        // example: apiPrompt.example,
        // imageName: apiPrompt.imageName,
        // imageData: apiPrompt.imageData,
        // hex: apiPrompt.imageData.colors.MainColor,
        // likes: apiPrompt.likes,
        // visits: apiPrompt.visits,
        // video: apiPrompt.videoData.url || {},
        isEditorial,
        // avatar: apiPrompt?.author?.image,
        // image: apiPrompt.imageData.urlOptimized,
        // isLiked: apiPrompt.isLiked,
        // Берем первые 3 категории и преобразуем в русские названия
        // tags: mapCategoriesToRussian(apiPrompt.categoriesEn.slice(0, 3)),
    };
};

/**
 * Адаптация данных курса из API под формат frontend
 */
//eslint-disable-next-line @typescript-eslint/no-explicit-any
export const transformApiCoursesToFrontend = (apiCourse: Course): any => {
    return {
        ...transformCourseToCard(apiCourse),
        type: 'course',
    };
};

/**
 * Адаптация данных челленджа из API под формат frontend
 */
//eslint-disable-next-line @typescript-eslint/no-explicit-any
export const transformApiChallengesToFrontend = (apiChallenge: Challenge): any => {
    return {
        ...apiChallenge,
        type: 'challenge',
    };
};
